export default __webpack_public_path__ + "static/media/notFound.08740295.png";